module.exports = __webpack_public_path__ + "static/media/thomas.dcae42a0.jpg";